import * as React from 'react';
import {livemodeMustUseHttpsMessage} from '@stripe-internal/connect-embedded-lib';
import type {ISecureContextMetadata} from '@stripe-internal/connect-embedded-lib';
import {useAuthContext} from '../AuthContext/AuthContext';
import {DevNotice} from '../../components/DevNotice';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';
import {useEmitEvent} from '../EventEmitterContext';

type Props = {
  children: React.ReactNode;
  browserSecureContext: ISecureContextMetadata;
  connectElement: ConnectElementImportKeys;
};

/**
 * This component validates that the merchant is not using HTTP/invalid protocols. There is an allowlist for certain platforms that
 * are still doing this and we don't want to break
 * We emit a load error when this validation triggers
 */
export const SecureContextEnforcer: React.FC<Props> = ({
  children,
  browserSecureContext,
  connectElement,
}) => {
  const {authInfo} = useAuthContext();
  const emitEvent = useEmitEvent();

  const shouldBlockRendering =
    browserSecureContext.evaluation.result === 'error' && authInfo;

  React.useEffect(() => {
    if (shouldBlockRendering) {
      // Emit a load error event to the platform with the relevant message
      emitEvent('loaderror', {
        error: {
          type: 'invalid_request_error',
          message: livemodeMustUseHttpsMessage,
        },
      });
    }
  }, [shouldBlockRendering, emitEvent]);

  if (shouldBlockRendering) {
    // We render nothing (this notice renders only for developers)
    return (
      <DevNotice
        type="mustUseHttpsInLivemode"
        connectElement={connectElement}
      />
    );
  }

  // Simple pass through
  return <>{children}</>;
};
